import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getResume } from './store/action.js';
import App from './App.js';

function mapPropsToState(state){
	return {
		resume: state,
	}
}

function mapDispatchToProps(dispatch) {
	return {
		getResume: bindActionCreators(getResume, dispatch),
	}
}

export default connect(mapPropsToState, mapDispatchToProps)(App);
